/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { ChangePasswordContainer } from "../../containers/account/ChangePasswordContainer"
import { Stack, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export default function PasswordSettings({ isPartnerSection }: { isPartnerSection: boolean }): JSX.Element {
  if (isPartnerSection) {
    return (
      <Stack>
        <Typography variant="h2">
          <FormattedMessage defaultMessage="Partner password" />
        </Typography>
        {/*ChangePasswordContainer still needs to be updated to use new carotene-core components*/}
        <ChangePasswordContainer />
      </Stack>
    )
  }
  return (
    <Stack>
      <Typography variant="h2">
        <FormattedMessage defaultMessage="Password" />
      </Typography>
      {/*ChangePasswordContainer still needs to be updated to use new carotene-core components*/}
      <ChangePasswordContainer />
    </Stack>
  )
}
